import { Scanner } from '@yudiel/react-qr-scanner';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useEvent } from '../../../../data/hooks/eventHooks';
import { useI18n } from '../../../../data/hooks/i18nHooks';
import { useIsBusy } from '../../../../data/hooks/ui/useIsBusy';
import { dialogAlert } from '../../../elements/Dialog/dialogs';
import RelativeRedirect from '../../../elements/RelativeRedirect/RelativeRedirect';
import TopBarEvent from '../../../elements/TopBar/TopBarEvent';
import Screen from '../../Screen';
import NewLeadModal from './NewLeadModal';
import LeadManualInputIcon from './LeadManualInputIcon';
import ManualInputModal from './ManualInputModal';
import { useScannableSponsors } from './useScannableSponsors';
import PickSponsorModal from './PickSponsorModal';

function EventLeadsScanScreen(props) {
    const { eventId } = props,
        event = useEvent(eventId),
        sponsors = useScannableSponsors(eventId),
        [sponsorId, setSponsorId] = useState(sponsors.length > 1 ? null : sponsors[0]?.id),
        busy = useIsBusy(),
        dispatch = useDispatch(),
        i18n = useI18n(),
        [manualMode, setManualMode] = useState(false),
        [newLead, setNewLead] = useState(),
        paused = busy || newLead || manualMode;

    useEffect(() => {
        setManualMode(false);
    }, [newLead]);

    const handleAddCode = useCallback(
        (code) => {
            dispatch(app.actions.ui.busy());
            app.api.leads
                .create(eventId, sponsorId, code)
                .then((lead) => {
                    setNewLead(lead);
                })
                .catch(async (err) => {
                    await dialogAlert(i18n['error.leadscan.registration-not-found']);
                })
                .finally(() => {
                    dispatch(app.actions.ui.free());
                });
        },
        [eventId, sponsorId, i18n]
    );

    const handleCodeScanned = useCallback((data) => {
        const code = data[0]?.rawValue;
        if (code) {
            handleAddCode(code);
        }
    }, []);

    const handleCancel = useCallback(() => app.history.replace('..'), []);

    const handleCloseModal = useCallback(() => setNewLead(false), []);

    if (!sponsors.length) return <RelativeRedirect to=".." />;

    const header = <TopBarEvent event={event} icons={[<LeadManualInputIcon key="manual" onClick={() => setManualMode(true)} />]} />;

    return (
        <Screen header={header}>
            <Scanner onScan={handleCodeScanned} paused={paused} />
            <NewLeadModal event={event} lead={newLead} onClose={handleCloseModal} />
            <ManualInputModal open={manualMode} onClose={() => setManualMode(false)} onAddCode={handleAddCode} />
            <PickSponsorModal event={event} open={!sponsorId} sponsors={sponsors} onSelect={setSponsorId} onClose={handleCancel} />
        </Screen>
    );
}

export default (props) => <EventLeadsScanScreen {...props.match.params} />;
